<div class="header">
    <div class="file-name-container">
        <button type="button" class="mr-3" mat-dialog-close>
            <mat-icon class="icon-color" title="back">arrow_back</mat-icon>
        </button>
        <span class="icon-color title-font overflow-ellipsis">{{ fileName }}</span>
    </div>

    <div class="action-items-container">
        <button type="button" (click)="imageZoomIn()" [disabled]="scaleValue === maximumZoom">
            <mat-icon class="icon-color" [ngClass]="scaleValue === maximumZoom ? 'color-grey': ''"
                title="click to zoom out">zoom_in</mat-icon>
        </button>
        <button type="button" (click)="imageZoomOut()" [disabled]="scaleValue === minimumZoom">
            <mat-icon class="icon-color" [ngClass]="scaleValue === minimumZoom ? 'color-grey': ''"
                title="click to zoom in">zoom_out</mat-icon>
        </button>
        <button type="button">
            <a [href]="imageURL" target="_blank" title="download" class="mat-icon">
                <mat-icon class="icon-color">save_alt</mat-icon>
            </a>
        </button>
    </div>
</div>

<div class="zoom-level" *ngIf="showZoomLevel">
    {{ scaleValue*100 }}%
</div>

<div #imageContainer class="enlarged-image">
    <img #image [src]="imageURL" alt="Unable to load Image" class="image" (dblclick)="toggleZoomInZoomOut()" />
</div>